import { string, number, shape, bool } from "prop-types";

export const echeqPropTypes = {
    numero_chequera: string.isRequired,
    cheque_numero: string.isRequired,
    beneficiario_nombre: string.isRequired,
    beneficiario_documento_tipo: string.isRequired,
    beneficiario_documento: string.isRequired,
    monto: number.isRequired,
    fecha_pago: string.isRequired,
    emisor_cuit: string.isRequired,
    emisor_razon_social: string.isRequired,
    emisor_moneda: string.isRequired,
    fecha_emision: string.isRequired,
    extra_info: string.isRequired,
    estado: string.isRequired,
    cheque_tipo: string.isRequired,
    cheque_modo: number.isRequired,
    cheque_caracter: string.isRequired,
    cheque_concepto: string.isRequired,
    cheque_motivo_pago: string.isRequired,
    cheque_id: string.isRequired,
    tenencia_beneficiario_nombre: string.isRequired,
    tenencia_beneficiario_documento_tipo: string.isRequired,
    tenencia_beneficiario_documento: string.isRequired,
    total_endosos: number.isRequired,
    total_cesiones: number.isRequired,
    endosos: shape({}).isRequired,
    cesiones: shape({}).isRequired,
    cesion_pendiente: bool.isRequired,
    certificado_emitido: bool.isRequired,
    re_presentar: bool.isRequired,
    cheque_acordado: bool.isRequired,
    solicitando_acuerdo: bool.isRequired,
    cuit_solic_devol: string.isRequired,
};

export default echeqPropTypes;
